<iframe class="gameFrame" allowtransparency="true"  allowfullscreen="true" [src]="LinkProva" frameborder="0" scrolling="no"> </iframe>